/**
 * Feature Grid – Swiper slider on mobile only
 */
(function () {
  function initFeatureGridSwipers() {
    if (typeof window.Swiper === 'undefined') return;

    const containers = document.querySelectorAll('[data-feature-grid-swiper]');
    if (!containers.length) return;

    containers.forEach((el) => {
      if (el.swiper) return; // already initialized

      const sectionId = el.closest('[data-section-id]')?.dataset?.sectionId;
      const swiper = new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true
        },
        grabCursor: true,
        resistance: true,
        resistanceRatio: 0.85,
        breakpoints: {
          750: {
            allowTouchMove: false,
            pagination: false
          }
        },
        on: {
          init() {
            document.dispatchEvent(
              new CustomEvent('feature-grid:swiper-init', {
                detail: { sectionId, swiper: this }
              })
            );
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeatureGridSwipers);
  } else {
    initFeatureGridSwipers();
  }

  // Re-init when Shopify section is re-rendered (theme editor)
  document.addEventListener('shopify:section:load', initFeatureGridSwipers);
})();
